// import Navbar from "../components/navbar";
// import FooterTopImage from "../components/FoterTopImage";
// import Footer from "../components/footer";
// import React from "react";

// export default function Login() {
//     return (
//         <>
//             <Navbar navClass="defaultscroll sticky" menuClass = "navigation-menu nav-left"/>
//             <section className="position-relative mt-5 pt-4">
//                 <div className="container-fluid px-md-4 px-2 mt-2">
//                     <h1>Login Page</h1>
//                 </div>
//             </section>
//             <FooterTopImage/>
//             <Footer/>
//         </>)
// }



//=================================================================================================



import { useState } from 'react';
import axios from 'axios'
import { useNavigate } from 'react-router-dom';
const LoginPage = () => {
    const navigate = useNavigate(); // add this at the top of your component
    const [credentials, setCredentials] = useState({
        email: '',
        password: ''
    });
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');
    const [token, setToken] = useState('');
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const loginPath = `${process.env.REACT_APP_API_URL}api/Auth/login`;
    const handleChange = (e) => {
        const { name, value } = e.target;
        setCredentials({
            ...credentials,
            [name]: value
        });
    };

    const handleSubmit = async (e) => {
        if (e) e.preventDefault();
        setIsLoading(true);
        setError('');

        const { email, password } = credentials;

        // Basic validation
        if (!email || !password) {
            setError('Email and password are required.');
            setIsLoading(false);
            return;
        }

        // Email format check
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            setError('Please enter a valid email address.');
            setIsLoading(false);
            return;
        }

        try {
            const response = await axios.post(loginPath, credentials);

            const data = response.data
            // Store token and role in localStorage
            localStorage.setItem('token', data.token);
            localStorage.setItem('role', data.user.roles[0]); // assuming only one role
            localStorage.setItem('userEmail', data.user.email); // optional if needed later
            localStorage.setItem('userId', data.user.id); // optional if needed later


            setToken(data.token);
            setIsLoggedIn(true);
            // ✅ Navigate to admin panel
            navigate('/adminPanel');
        } catch (err) {
            setError('Failed to login');
        } finally {
            setIsLoading(false);
        }
    };

    const handleLogout = () => {
        setToken('');
        setIsLoggedIn(false);
    };

    return (
        <div className="d-flex min-vh-100 align-items-center bg-light">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-md-8 col-lg-6 col-xl-5">
                        <div className="card shadow-sm border-0 rounded-4">
                            <div className="card-body p-4 p-sm-5">
                                {!isLoggedIn && (
                                    <>
                                        <div className="text-center mb-4">
                                            <h2 className="fw-bold text-primary">Login</h2>
                                        </div>

                                        {error && (
                                            <div className="alert alert-danger alert-dismissible fade show" role="alert">
                                                {error}
                                                <button
                                                    type="button"
                                                    className="btn-close"
                                                    onClick={() => setError('')}
                                                    aria-label="Close"
                                                ></button>
                                            </div>
                                        )}

                                        <form onSubmit={handleSubmit}>
                                            <div className="mb-3">
                                                <label htmlFor="username" className="form-label">Email</label>
                                                <div className="input-group">
                                                    <span className="input-group-text">
                                                        <i className="bi bi-person-fill"></i>
                                                    </span>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        id="email"
                                                        name="email"
                                                        value={credentials.email}
                                                        onChange={handleChange}
                                                        required
                                                    />
                                                </div>
                                            </div>

                                            <div className="mb-4">
                                                <label htmlFor="password" className="form-label">Password</label>
                                                <div className="input-group">
                                                    <span className="input-group-text">
                                                        <i className="bi bi-lock-fill"></i>
                                                    </span>
                                                    <input
                                                        type="password"
                                                        className="form-control"
                                                        id="password"
                                                        name="password"
                                                        value={credentials.password}
                                                        onChange={handleChange}
                                                        required
                                                    />
                                                </div>
                                            </div>

                                            <div className="d-grid">
                                                <button
                                                    type="submit"
                                                    className="btn btn-primary btn-lg"
                                                    disabled={isLoading}
                                                >
                                                    {isLoading ? (
                                                        <>
                                                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                            Logging in...
                                                        </>
                                                    ) : 'Login'}
                                                </button>
                                            </div>
                                        </form>
                                    </>
                                ) }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LoginPage;
